import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Paper, Grid, Typography, Button } from '@mui/material';
import {
  PeopleAlt as PeopleIcon,
  PersonAdd as AddAccountIcon,
  ModeEdit as EditIcon,
  ArrowCircleRight as RightArrowIcon,
} from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

import Accordion from 'components/accordion';
import { fetchCourses } from 'redux/actions';

import CardSets from './CardSets';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'inherit',
    padding: theme.spacing(3),
  },
  membersPaper: {
    padding: theme.spacing(2),
    backgroundColor: '#794b6b',
    color: '#fff',
    borderRadius: '8px',
  },
  coursesPaper: {
    padding: theme.spacing(2),
    backgroundColor: '#5b8d8b',
    color: '#fff',
    borderRadius: '8px',
  },
  memberButton: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    backgroundColor: '#fff',
    fontSize: '0.75rem',
    color: '#000',
    borderRadius: '16px',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
    },
    '& svg': {
      fontSize: '14px',
    },
  },
  editButton: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(1, 2),
    backgroundColor: '#2b2f2e',
    marginTop: '30px',
    marginBottom: '15px',
    marginLeft: '20px',
    color: '#fff',
    borderRadius: '32px',
    '&:hover': {
      backgroundColor: '#2b2f2e',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
    },
  },
  setsButton: {
    padding: theme.spacing(1, 3),
    backgroundColor: '#bf9d30',
    color: '#fff',
    borderRadius: '24px',
    '&:hover': {
      backgroundColor: '#c1a037',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
  },
}));

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector((state) => state?.user);
  const courses = useSelector((state) => state?.courses);

  useEffect(() => {
    dispatch(fetchCourses());
  }, [dispatch]);

  return (
    <Paper elevation={0} className={classes.paper}>
      <Grid container>
        <Grid item xs={12} sm={6} sx={{ minHeight: '100px' }}>
          <Typography>Tucci Learning Solutions</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Grid container justifyContent='space-between'>
            <Grid item xs={6}>
              <Typography variant='h4'>Dashboard</Typography>
              <Typography>Welcome {user?.full_name}!</Typography>
            </Grid>
            <Grid item xs={6} textAlign='right'>
              <Button
                className={classes.setsButton}
                onClick={() => navigate('/sets')}
              >
                My Sets
                <RightArrowIcon sx={{ marginLeft: '8px' }} />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: '16px' }}>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.membersPaper} elevation={12}>
            <Typography>Members</Typography>
            <Typography component='div' sx={{ marginTop: '24px' }}>
              <Button
                className={classes.memberButton}
                onClick={() => navigate('/admin/users')}
              >
                <PeopleIcon sx={{ marginRight: '8px' }} />
                Manage Members
              </Button>
              <Button
                className={classes.memberButton}
                onClick={() => navigate('/admin/users/new')}
              >
                <AddAccountIcon sx={{ marginRight: '8px' }} />
                New Account
              </Button>
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.coursesPaper} elevation={12}>
            <Typography sx={{ marginBottom: '16px' }}>Courses</Typography>
            {courses &&
              courses.map((course) => (
                <Accordion title={course.name} key={course.id}>
                  <CardSets />
                </Accordion>
              ))}
            {user.level === 4 && (
              <Button
                className={classes.editButton}
                onClick={() => navigate('/admin/courses')}
              >
                <EditIcon sx={{ marginRight: '8px' }} />
                Manage Courses
              </Button>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Dashboard;
